/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useQuery } from "@tanstack/react-query";

export function useQISUGLinkedQuestion(
  courseId: number,
  questionId?: number,
  prev?: boolean,
  iso?: string,
): {
  linkedQuestion: QuestionIndexing.UsQiQuestion;
  linkedQuestionLoading: boolean;
  linkedQuestionError: any;
} {
  const shouldFetch = !!courseId && !!iso;

  //@ts-ignore
  const fetcher = (...args) => fetch(...args).then((res) => res.json());

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: ["qi sug linked questions", courseId, iso, questionId, prev],
    queryFn: () =>
      fetcher(
        `/api/questions/sugLinkedQuestion/${courseId}/?lang=${iso}&questionId=${questionId}&prev=${prev}`,
      ),
    enabled: shouldFetch,
  });

  return {
    linkedQuestion: data,
    linkedQuestionLoading: isLoading,
    linkedQuestionError: error,
  };
}
